export const COLLECTION_MIS_REQUEST = 'COLLECTION_MIS_REQUEST';
export const COLLECTION_MIS_SUCCESS = 'COLLECTION_MIS_SUCCESS';
export const COLLECTION_MIS_FAIL = 'COLLECTION_MIS_FAIL';

export const COLLECTION_SUPERVISORS_REQUEST = 'COLLECTION_SUPERVISORS_REQUEST';
export const COLLECTION_SUPERVISORS_SUCCESS = 'COLLECTION_SUPERVISORS_SUCCESS';
export const COLLECTION_SUPERVISORS_FAIL = 'COLLECTION_SUPERVISORS_FAIL';
